<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="full-middle"
      @open="modalOpen"
      @cancel="cancel"
      @confirm="confirm"
      :contentStyle="{'height': '100%', display: 'flex', 'flex-direction': 'column'}"
  >
    <template #header>
      <span>添加产品</span>
    </template>
    <template #content>
      <app-base-main :table-shadow="false" no-padding parent-table>
        <template #filter-group>
          <app-filter-group
              :reset="false"
              @query="$gjNoticeQuery">
            <gj-select-input
                v-model="filter.keyword"
                :options="option.keyword"
                :width="['100px', '150px']"
            ></gj-select-input>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              adapt-parent
              selection
              :offset-height="75"
              :pagination="pagination"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
            <template v-slot:sku="{row}">
              <div>
                <gj-tooltip
                    :text-line="1"
                    :content="row.skuName">
                  {{row.skuName | defaultShow}}
                </gj-tooltip>
              </div>
              <div>{{row.sku | defaultShow}}</div>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>

  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import {defaultVal} from "@/utils/common";
  import {getCostSupplementAddProductPage} from "@/api/warehouse";

  export default {
    name: "app-add-product-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      warehouseId: {
        required: true,
      },
      costType: {
        required: true,
      },
      hideSkuList: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '50px'},
          {id: 'productName', header: '产品名称', field: 'productName', minWidth: '200px'},
          {id: 'sku', header: 'SKU', field: 'sku', minWidth: '200px'},
        ],
        filter: {
          keyword: {
            key: 'sku',
            value: null
          },
        },
        option: {
          keyword: [
            {id: 'sku', text: 'SKU'},
            {id: 'productName', text: '产品名称'},
          ],
        }
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            warehouseId: this.warehouseId,
            costType: this.costType,
            [this.filter.keyword.key]: defaultVal(this.filter.keyword.value),
            hideSkuList: this.hideSkuList,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getCostSupplementAddProductPage(params)
          .then(data => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      },
      confirm() {
        if (this.selectedRows.length === 0) {
          this.$gjMessage.error('请勾选产品');
          return;
        }
        this.$emit('select', this.selectedRows);
        this.$gjDestroy();
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
